import type { IdleCallUsecase } from '@usecases/idle-call.usecase';

import type { BaseController } from '@infra/controllers/base.controller';

export type IdleCallInput = void;

export type IdleCallOutput = void;

export class IdleCallController
  implements BaseController<IdleCallInput, IdleCallOutput>
{
  constructor(private usecase: IdleCallUsecase) {}

  async handle(): Promise<IdleCallOutput> {
    await this.usecase.run();
  }
}
